interface ICookieConsentConfig {
  htmlElements: ICookieConsentHTMLElements,
  selectors: ICookieConsentSelectors,
  localStorageKey: string
}

interface ICookieConsentSelectors {
  panel: string,
  close: string
}

interface ICookieConsentHTMLElements {
  panel: HTMLElement,
  close: HTMLElement
}

class CookieConsent {

  private config:ICookieConsentConfig;

  constructor() {
    this.config = {
      localStorageKey: 'hasConsent',
      htmlElements: {
        panel: null,
        close: null
      },
      selectors: {
        panel: '[data-cookie-consent]',
        close: '[data-cookie-consent-close]'
      }
    }
  }
  
  init() {
    const hasConsent = window.localStorage.getItem(this.config.localStorageKey);
    this.config.htmlElements.panel = document.querySelector(this.config.selectors.panel);
    this.config.htmlElements.close = document.querySelector(this.config.selectors.close);
    if (hasConsent !== '') this.config.htmlElements.panel.classList.remove('hide');
    this.addEventListeners();
  }

  addEventListeners() {
    this.config.htmlElements.close.addEventListener('click', this.handleCloseClick.bind(this));
  }

  handleCloseClick() {
    window.localStorage.setItem(this.config.localStorageKey, '');
    this.config.htmlElements.panel.classList.add('hide');
  }
}

export default new CookieConsent();